import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPatientIntervalsAction,
  resetPatientIntervalsAction,
} from 'src/redux/actions/documentBundleActions';
import { PatientIntervals } from '../by-patient/types';

const EMPTY: PatientIntervals = {
  earliestDos: null,
  latestDos: null,
  stays: [],
  coverage: [],
};

/**
 * SQ-161: the resident's stays and payer coverage periods.
 *
 * Both lists arrive in one call and neither is derived from the other — coverage is not
 * nested inside episodes (C5), so an empty `coverage` means that basis is disabled, not
 * that it should be hidden.
 */
export function usePatientIntervals(patientUuid: string | null) {
  const dispatch = useDispatch();
  const { response, loading } = useSelector((state: any) => state.getPatientIntervalsReducer);

  useEffect(() => {
    if (!patientUuid) {
      dispatch(resetPatientIntervalsAction());
      return;
    }
    dispatch(getPatientIntervalsAction(patientUuid));
  }, [patientUuid, dispatch]);

  const intervals: PatientIntervals = useMemo(() => response ?? EMPTY, [response]);

  return { intervals, loading };
}
